// src/components/layout/FloatingNav.jsx

import React from 'react';
import { Home, Sparkles, BookOpen, Settings } from 'lucide-react';

const NAV_ITEMS = [
  { id: 'home',       icon: Home,      label: 'Beranda'    },
  { id: 'analyze',    icon: Sparkles,  label: 'Analisis'   },
  { id: 'dictionary', icon: BookOpen,  label: 'Kamus'      },
  { id: 'settings',   icon: Settings,  label: 'Pengaturan' },
];

export default function FloatingNav({ activeTab, onTabChange }) {
  return (
    <div
      className="
        absolute
        bottom-0 left-0 right-0
        z-50 no-print
      "
      style={{
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {/*
        Kontainer Nav:
        - Diperbesar: py-2.5, gap-1
        - Margin tetap: mx-3 mb-3
        - Padding internal: lebih besar untuk area sentuh yang nyaman
      */}
      <div
        className="
          mx-3 mb-3
          px-2 py-2.5
          bg-white/95 dark:bg-slate-900/95
          backdrop-blur-xl
          rounded-[28px]
          shadow-[0_8px_32px_rgba(0,0,0,0.15)]
          border border-stone-100/80 dark:border-slate-700
        "
      >
        <div className="flex items-center justify-around gap-1">
          {NAV_ITEMS.map((item) => {
            const Icon     = item.icon;
            const isActive = activeTab === item.id;

            return (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={`
                  relative flex flex-col items-center justify-center
                  gap-1
                  px-4 py-2.5
                  rounded-2xl
                  transition-all duration-200 active:scale-95
                  min-w-[68px] min-h-[56px]
                  ${isActive
                    ? 'bg-gradient-to-br from-green-400 to-green-600 text-white scale-105 shadow-md shadow-green-500/30'
                    : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-stone-100 dark:hover:bg-slate-800'
                  }
                `}
              >
                <Icon
                  className="w-[22px] h-[22px]"
                  strokeWidth={isActive ? 2.5 : 2}
                />
                <span
                  className={`
                    text-[10px] leading-none font-semibold
                    ${isActive ? 'font-extrabold' : ''}
                  `}
                >
                  {item.label}
                </span>

                {/* Titik indikator aktif */}
                {isActive && (
                  <span
                    className="
                      absolute -bottom-0.5 left-1/2 -translate-x-1/2
                      w-1.5 h-1.5 bg-white/80 rounded-full
                    "
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}